import { IHttpInterceptor, IHttpResponse, IRequestConfig } from 'angular';

export interface IHttpInterceptorsRegistry extends IHttpInterceptor {
	register(interceptor: IHttpInterceptor): boolean;
}

export function httpInterceptorsRegistry(): IHttpInterceptorsRegistry {
	const interceptors = [] as IHttpInterceptor[];

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	async function handle(interceptorProperty: 'request' | 'response', attr: any) {
		for (const interceptor of interceptors) {
			const property = interceptor[interceptorProperty];
			if (typeof property === 'function') {
				attr = await property(attr);
			}
		}
		return attr;
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	async function handleRejection(interceptorProperty: 'requestError' | 'responseError', attr: any): Promise<unknown> {
		for (const interceptor of interceptors) {
			const property = interceptor[interceptorProperty];
			if (typeof property === 'function') {
				try {
					return await property(attr);
				} catch (rejection) {
					attr = rejection;
				}
			}
		}
		throw attr;
	}

	return {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		async responseError<T>(responseRejection: any) {
			return (await handleRejection('responseError', responseRejection)) as IHttpResponse<T>;
		},

		response: async function <T>(attr: IHttpResponse<T>) {
			return await handle('response', attr);
		},

		request: async function (attr: IRequestConfig) {
			return await handle('request', attr);
		},

		requestError: async function (rejection) {
			return (await handleRejection('requestError', rejection)) as IRequestConfig;
		},

		register(interceptor: IHttpInterceptor) {
			if (!interceptor || typeof interceptor !== 'object') {
				return false;
			}

			interceptors.push(interceptor);
			return true;
		},
	};
}
